<template>
  <div>
    <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <h4 v-if="showAddressAndSite" >{{ this.$store.state.site.name }}<br>
            <small> {{this.$store.state.site.address}}</small>
            <hr>
          </h4>
        </div>
        <h4>
          <div class="box red"><span class="text-center">{{ labName + ' ' +  translatedFields['disclaimer'] }}</span></div>
        </h4>
        <label class="control-label">
        </label>
        <p v-html="disclaimer_text">
        </p>
        <hr>
        <p-checkbox v-model="model.agreed" name="agreed"
                    v-validate="modelValidations.agreed"
        > {{ translatedFields['i_agree'] }} </p-checkbox>
        <small class="text-danger" v-show="agreed.invalid">
          {{ getError('agreed') }}
        </small>
      </div>
    </div>

  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'

  export default {
    data () {
      return {
        labName: process.env.LAB_NAME,
        showAddressAndSite: process.env.SHOW_ADDRESS_DISCLAIMER,
        model: {
          agreed: false
        },
        translatedFields: '',
        text: '',
        modelValidations: {
          siteCode: {
            min: 5,
            required: true
          },
          agreed: {
            required: true
          }
        },
        fields_en: {
          i_agree: 'I agree',
          disclaimer: 'Disclaimer'
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        if (!this.model.agreed) {
          this.$validator.errors.add({field: 'agreed', msg: 'Please accept!'})
          let field = this.$validator._resolveField('agreed')
          field.setFlags({invalid: true})
          return false
        }
        return this.$validator.validateAll()
      },
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      }
    },
    computed: {
      disclaimer_text () {
        if (this.$store.state.lang.value === 'ES' && this.$store.state.site.patient_disclaimer_es) {
          this.text = this.$store.state.site.patient_disclaimer_es
        } else {
          if (this.$store.state.lang.value === 'ZH' && this.$store.state.site.patient_disclaimer_zh) {
            this.text = this.$store.state.site.patient_disclaimer_zh
          } else {
            if (this.$store.state.lang.value === 'EN' && this.$store.state.site.patient_disclaimer) {
              this.text = this.$store.state.site.patient_disclaimer
            }
          }
        }
        let linksArray = this.text.match(/<a href="(.*?)">/g)
        if (linksArray) {
          for (let i = 0; i < linksArray.length; i++) {
              // if doesn't have target already put it
            if (!linksArray[i].includes('target="_blank')) {
              // controll if link has protocol if yes just add target
              if (linksArray[i].includes('http') || linksArray[i].includes('https') || linksArray[i].includes('href="//')) {
                let toReturn = linksArray[i].slice(0, linksArray[i].indexOf('>')) + ' target="_blank"' + linksArray[i].slice(linksArray[i].indexOf('>'))
                this.text = this.text.replace(linksArray[i], toReturn)
                // if it doesn't have protocol add // so it wont redirect to localhost/www.userlink.com
              } else {
                let toReturn = linksArray[i].slice(0, linksArray[i].indexOf('href="') + 6) + '//' + linksArray[i].slice(9)
                this.text = this.text.replace(linksArray[i], toReturn)
              }
            }
          }
        }
        return this.text
      },
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      },
      ...mapFields(['agreed'])
    },
    watch: {
      language () {
        this.checkLanguage()
      }
    }
  }
</script>

<style scoped>
  span{
    position: relative;
    padding-left: 25px;
    font-size: 1.25em;
    font-weight: 400;
    line-height: 1.4em;
  }
  /*
  span:before{
    position: absolute;
    content: "";
    width: 18px;
    height: 18px;
    margin: 10px 10px 10px 0px;
    left: 0;
    background-color:red;
    border: 1px solid black;
  }
  */
  .box {
    margin-top: 20px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Patient/Wizard/DisclaimerStep.vue